module.exports = __webpack_public_path__ + "img/20141009171705_56419.26ea2667.jpg";